import { gql } from "@apollo/client";

export const MESSAGES_DATA_COUNT = gql`
query getMessageCount($start:date $end:date){
  reporting_MessageStatusByReseller(where: {
        Date:{_gte: $start ,_lte:$end }
      }) {
        SentCount
    		Date
    }
}
`;  